
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { useEffect } from 'react';

function useUnmountEffect(callback) {
    return useEffect(function () { return function () { return callback(); }; }, []);
}

export { useUnmountEffect };
//# sourceMappingURL=use-unmount-effect.mjs.js.map
